import { OutlinedInputProps } from '@mui/material';
import MuiTextField, { BaseTextFieldProps } from '@mui/material/TextField';
import ModulEnum from "src/enums/ModulEnum";
import { useAppSelector } from 'src/store';
import { isVisible } from 'src/utils/formAuthHelper';

export interface ITextFieldProps extends BaseTextFieldProps {
  onChange?: OutlinedInputProps['onChange'];
  InputProps?: Partial<OutlinedInputProps>;
  authCode?: string;
  modul?: ModulEnum;
  borderNone?: boolean;
  bgcolor?: string;
}

// export interface TTextFieldProps extends NewType {
//   onChange?: (event: { target: { name: string; value: string } }) => void;
//   name?: string;
//   InputProps?: Partial<OutlinedInputProps>;
// }

const TextField = (props: ITextFieldProps): JSX.Element => {
  const formSize = useAppSelector(s => s.userLogin.formSize)
  const { authCode, modul, borderNone, ...rest } = props;
  return (
    isVisible(authCode, modul) && (
      <MuiTextField
        {...rest}
        sx={{
          "&.MuiTextField-root .MuiInputBase-root": {
            height: props.multiline ? "auto" : formSize * 2.8,
            backgroundColor: props.bgcolor && props.bgcolor,
          },
          '& fieldset': { border: borderNone ? 'none' : "auto" },

        }}
        variant="outlined"
        fullWidth={!(props.fullWidth === false)}
        autoComplete={props.autoComplete === undefined ? "off" : props.autoComplete}
        InputLabelProps={{ ...props.InputLabelProps, shrink: true, className: "textFieldLabel" }}
        value={(props.value === "undefined" || props.value === null || props.value === "null") ? "" : props.value}
        size={"small"}
      />
    )
  );
};

export default TextField;

